import type { FC } from 'react';
import { Accordion } from '@chakra-ui/react';
import { Email } from '../email';
import {
    AccordionAboutLinks,
    AccordionCustomerServiceLinks,
    AccordionExperienceLinks,
} from '../link-groups';
import { Social } from '../social';

export const FooterMobile: FC = () => (
    <div data-testid="footer-mobile-container" className="flex h-full w-full flex-col gap-10">
        <div className="flex-1">
            <Email />
        </div>
        <Accordion allowToggle borderBottom="1px solid #CCC">
            <AccordionExperienceLinks />
            <AccordionCustomerServiceLinks />
            <AccordionAboutLinks />
        </Accordion>
        <div className="flex-1">
            <Social />
        </div>
    </div>
);
